(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["november-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  var launch = Date.parse('2026-11-01T00:00:00-03:00');

  function startTimers(scope) {
    scope.querySelectorAll('[data-ttt-november]').forEach(function (section) {
      if (section.dataset.tttTimerReady === 'yes') return;
      section.dataset.tttTimerReady = 'yes';

      var days = section.querySelector('[data-ttt-days]');
      var hours = section.querySelector('[data-ttt-hours]');
      var minutes = section.querySelector('[data-ttt-minutes]');
      var seconds = section.querySelector('[data-ttt-seconds]');
      var before = section.querySelector('[data-ttt-before]');
      var after = section.querySelector('[data-ttt-after]');
      var timer;

      function update() {
        if (!section.isConnected) { clearInterval(timer); return; }
        var remaining = Math.max(0, launch - Date.now());
        days.textContent = String(Math.floor(remaining / 86400000)).padStart(2, '0');
        hours.textContent = String(Math.floor((remaining % 86400000) / 3600000)).padStart(2, '0');
        minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
        seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
        if (remaining === 0) {
          before.hidden = true;
          after.hidden = false;
          clearInterval(timer);
        }
      }

      update();
      if (Date.now() < launch) timer = setInterval(update, 1000);
    });
  }

  function init() { startTimers(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) {
    startTimers(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
